/* eslint-disable import/no-cycle */
import update from 'immutability-helper';
import { createSelector } from 'reselect';

import { formTypes as formTypeConfig, pvqReviewSections } from 'config/formTypes';
import * as sections from 'constants/sections';

import { isFormSF852013, isPVQForm } from 'helpers/form';
import { getFormType } from '@redux/modules/application/selectors';
import { hideDisciplinaryProcedures } from '../validators/militarydisciplinary';
import { hideSelectiveService } from '../validators/selectiveservice';
import { hideExistingConditions } from '../validators/psychological';
import { isForeignBornUSCitizen } from '../validators/passport';

export const hideSelectiveServiceSelector = (state) => {
  const { application } = state;
  return hideSelectiveService(application);
};

export const hideDisciplinaryProceduresSelector = (state) => {
  const { application } = state;

  return hideDisciplinaryProcedures(application);
};

export const hideExistingConditionsSelector = (state) => {
  const { application } = state;

  return hideExistingConditions(application);
};

export const displayUSPassportSelector = (state) => {
  const { application = { Settings: {} } } = state;
  const { formType, formVersion } = application.Settings;

  return !isFormSF852013(formType, formVersion) || (isFormSF852013(formType, formVersion) && isForeignBornUSCitizen(application));
};

const filterSubsectionFromSection = (formTypeSections, sectionToUpdate, subsectionToFilter) => {
  const section = formTypeSections.find((s) => s.key === sectionToUpdate);
  const sectionIndex = formTypeSections.findIndex((s) => s.key === sectionToUpdate);
  const subsections = [...section.subsections].filter(
    (s) => s.key !== subsectionToFilter
  );

  const newSection = update(section, {
    subsections: { $set: subsections },
  });

  return update(formTypeSections, {
    $splice: [[sectionIndex, 1, newSection]],
  });
};

const getFormSections = createSelector(
  getFormType,
  hideDisciplinaryProceduresSelector,
  hideExistingConditionsSelector,
  displayUSPassportSelector,
  (formType, disciplinaryProceduresHidden, existingConditionsHidden, showUSPassport) => {
    // Make a copy b/c we are going to mutate this
    // Might want to add & use update here to make this easier
    let formTypeSections = formTypeConfig[formType];

    if (!showUSPassport) {
      formTypeSections = filterSubsectionFromSection(formTypeSections, sections.CITIZENSHIP, sections.CITIZENSHIP_US_PASSPORT);
    }

    if (disciplinaryProceduresHidden) {
      formTypeSections = filterSubsectionFromSection(formTypeSections, sections.MILITARY, sections.MILITARY_DISCIPLINARY);
    }

    if (existingConditionsHidden) {
      const psychSectionIndex = formTypeSections.findIndex((s) => s.key === sections.PSYCHOLOGICAL);

      if (psychSectionIndex > -1) {
        formTypeSections = filterSubsectionFromSection(formTypeSections, sections.PSYCHOLOGICAL, sections.PSYCHOLOGICAL_CONDITIONS);
      }
    }

    return formTypeSections;
  }
);

/**
 *  Returns form sections in the nested structure
 */
export const nestedFormSectionsSelector = (state, includeReview = false, isPVQ = false) => {
  const { application = { Settings: {} } } = state;
  const { formType } = application.Settings;
  let formSections = getFormSections(state);

  if (includeReview) { formSections = formSections.concat(isPVQForm(formType) ? formTypeConfig.pvqReviewSections : formTypeConfig.reviewSections); }

  return formSections;
};

/**
 *  Returns flat list of form sections
 */
export const formSectionsSelector = (state, includeReview = false, isPVQ = false) => {
  const { application = { Settings: {} } } = state;
  const { formType, formVersion } = application.Settings;
  let formSections = getFormSections(state);

  if (includeReview) { formSections = formSections.concat(isPVQForm(formType) ? formTypeConfig.pvqReviewSections : formTypeConfig.reviewSections); }

  return formTypeConfig.reduceSubsections(formSections);
};
